import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const GuitarPlayer: Site = {
  id: 'guitarplayer',
  logo: 'svg/guitarplayer.svg',
  label: 'Guitar Player',
  analyticsName: 'guitarplayer',
  hostname: 'guitarplayer.com',
  platform: 'responsive',
  selector: responsiveVanillaSelector,
};
